import { useModalState } from "@clipboard-health/ui-components";
import { getTheme } from "@clipboard-health/ui-theme";
import { isDefined } from "@clipboard-health/util-ts";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { RootPaths } from "@src/appV2/App/paths";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { ConfirmPhonePage } from "@src/appV2/redesign/Accounts/ConfirmPhonePage/Page";
import { type ReactElement } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { DeleteAccountConfirmationDialog } from "./DeleteAccountConfirmationDialog";
import { DeleteAccountDialog } from "./DeleteAccountDialog";

export function DeleteAccountPage(): ReactElement {
  const history = useHistory();
  const location = useLocation();

  const deleteAccountModalState = useModalState();
  const confirmDeleteAccountModalState = useModalState();

  return (
    <ThemeProvider theme={getTheme()}>
      <CssBaseline />
      <ConfirmPhonePage
        title="Delete Account"
        requestOtpEventName={APP_V2_USER_EVENTS.REQUEST_ACCOUNT_DELETION_SEND_OTP}
        onSuccess={() => {
          deleteAccountModalState.openModal();
        }}
        onCancel={() => {
          logEvent(APP_V2_USER_EVENTS.REQUEST_ACCOUNT_DELETION_CANCEL_AT_OTP);

          if (isDefined(location.key)) {
            history.goBack();
          } else {
            history.push(`${RootPaths.HOME}/account/profile`);
          }
        }}
      />

      <DeleteAccountDialog
        modalState={deleteAccountModalState}
        onSuccess={() => {
          deleteAccountModalState.closeModal();
          confirmDeleteAccountModalState.openModal();
        }}
        onFailure={() => {
          deleteAccountModalState.closeModal();
          confirmDeleteAccountModalState.closeModal();
        }}
      />

      <DeleteAccountConfirmationDialog modalState={confirmDeleteAccountModalState} />
    </ThemeProvider>
  );
}
